import styles from './Blur.module.scss';

export const Blur = ({ toTop }: { toTop?: boolean }) =>
  Array.from({ length: 6 }).map((_, index) => (
    <div key={index} className={toTop ? styles.blurTop : styles.blur} />
  ));
